import { getOutboxEntries, hasPendingOutboxEntries, logout } from '@sportschool/shared-logic';
import i18n from '@/i18n/i18n';

async function countPendingOutboxEntries(): Promise<number> {
  try {
    if (!(await hasPendingOutboxEntries())) return 0;
    return (await getOutboxEntries()).filter((e) => e.state === 'pending').length;
  } catch {
    return 0; // Outbox unavailable (e.g. IndexedDB blocked) — nothing to warn about.
  }
}

/**
 * Logs out after warning about unsent offline changes (coach outbox). The outbox is never deleted on logout —
 * the entries are sent after the same user signs in again on this device.
 */
export async function confirmAndLogout(): Promise<void> {
  const pendingCount = await countPendingOutboxEntries();
  if (pendingCount > 0 && !window.confirm(i18n.t('offline.logoutPendingConfirm', { count: pendingCount }))) return;
  await logout();
}
